module.exports = __webpack_public_path__ + "img/sign-74.125ae012.jpg";